import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { ArrowLeft, Calendar, User } from 'lucide-react';
import { useArticles } from '../hooks/useShopify';
import { Skeleton } from "@/components/ui/skeleton";

const ArticlePage = () => {
  const { id } = useParams();
  const { articles, loading } = useArticles();

  const article = articles.find(a => a.id === parseInt(id));

  if (loading) return <div className="container py-20"><Skeleton className="h-[400px] w-full" /></div>;
  if (!article) return <div className="container py-20 text-center">Artikkel ikke funnet. <Link to="/" className="text-primary underline">Gå hjem</Link></div>;

  return (
    <div className="min-h-screen bg-background py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <Link to="/" className="inline-flex items-center text-muted-foreground hover:text-primary mb-8">
          <ArrowLeft className="mr-2 h-4 w-4" /> Tilbake til forsiden
        </Link>

        <article>
          <div className="mb-6">
            <div className="flex items-center gap-4 text-sm text-muted-foreground mb-4">
              <span className="flex items-center gap-1"><Calendar className="h-4 w-4" /> {article.date}</span>
              <span className="flex items-center gap-1"><User className="h-4 w-4" /> Norsk Frøhandel</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-serif font-bold text-primary mb-6 leading-tight">
              {article.title}
            </h1>
            <p className="text-xl text-muted-foreground font-serif italic mb-8 border-l-4 border-accent pl-4">
              {article.excerpt}
            </p>
          </div>

          <div className="relative aspect-video rounded-2xl overflow-hidden mb-10 shadow-lg">
            <img 
              src={article.image} 
              alt={article.title} 
              className="w-full h-full object-cover"
            />
          </div>

          <div className="prose prose-lg max-w-none text-foreground/80">
            <p>
              Her kommer selve artikkelinnholdet. Dette er en plassholdertekst for å vise hvordan en artikkel vil se ut på nettsiden.
              Våre gartnere deler sine beste tips og triks for at du skal lykkes med hagen din.
            </p>
            <h3>Hvorfor velge riktig jord?</h3>
            <p>
              Planter trenger næring for å vokse seg store og sterke. Det er derfor viktig å velge riktig jordtype for plantene dine.
              Spør oss gjerne i butikken om hvilken jord som passer best til ditt prosjekt.
            </p>
            <h3>Vanning og stell</h3>
            <p>
              Husk å vanne jevnlig, spesielt i tørre perioder. Men pass på å ikke overvanne, da røttene kan råtne.
              Kjenn på jorden med fingeren før du vanner. Er den tørr, trenger planten vann.
            </p>
          </div>
        </article>

        <div className="mt-16 border-t pt-8 text-center">
          <h3 className="text-2xl font-serif font-bold text-primary mb-4">Likte du artikkelen?</h3>
          <p className="mb-6 text-muted-foreground">Del den med venner eller besøk oss for mer inspirasjon.</p>
          <div className="flex justify-center gap-4">
            <Link to="/category/alle">
              <Button>Se våre produkter</Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticlePage;
